import React from 'react';
import { useTranslation } from 'react-i18next';
import IconTitle from 'components/iconTitle/IconTitle';
import DocumentsTitleIcon from 'assets/images/documents/documents-title-icon.svg';

function DocumentsTitle() {
  const { t } = useTranslation();
  return <IconTitle title={t('documents.title')} icon={DocumentsTitleIcon} level={2} />;
}

export default DocumentsTitle;
